module.exports = __webpack_public_path__ + "img/delete-x.143493bc.svg";